import { AsyncReturnType } from "type-fest";

import { ConnectionService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<
  typeof ConnectionService.updateLinkedInConnection
>[0];
type Data = AsyncReturnType<typeof ConnectionService.updateLinkedInConnection>;
type Error = unknown;

export const useUpdateLinkedInConnection = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    ConnectionService.updateLinkedInConnection,
    options
  );

  return result;
};
